import { render } from "./TreeItem.vue?vue&type=template&id=2665b394&scoped=true"
import script from "./TreeItem.vue?vue&type=script&lang=js"
export * from "./TreeItem.vue?vue&type=script&lang=js"

import "./TreeItem.vue?vue&type=style&index=0&id=2665b394&scoped=true&lang=css"

import exportComponent from "D:\\01_Dev_Env_And_Workspace\\01_Active_Projects\\Vue_Frontend\\notemd-web\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_29d074f7dbbfd97370df878da6275bc8\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2665b394"]])

export default __exports__